import warehouseAccountingSystem from "assets/js/warehouseAccountingSystem";
import warehouseAnalyzeSystem from "assets/js/warehouseAnalyzeSystem";
import BasicSelect from "components/BasicInputs/BasicSelect";
import { S2N } from "helpers";
import NewSwitch from "pages/business/Subscription/NewSwitch";
import Switch from "pages/business/Subscription/Switch";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useSelector } from "react-redux";
import { BasicInput } from "../../../components/Input/BasicInput";

const AccountingSettings = ({ settingData, setSettingData }: any) => {
  const [accountingData, setAccountingData] = useState({
    taxRate: "9",
    addedTax: false,
  });
  console.log(`settingData is : ${JSON.stringify(settingData)}`)

  const onChange = (key: any, value: any) => {
    let temp = {
      ...settingData,
      [key]: value,
    };
    setSettingData(temp);
  };
  // const onChange = (value: any) => {};

  const store = useSelector((state: any) => state);
  const currencies = useSelector((state: any) => state.currencyReducer.currencies);
  const businessCurrencies = store?.businessReducer?.business?.business?.Currencies?.map((x: any) => ({
    label: x.fa_title,
    value: x.id,
  }));
  const multiCurrencyPlaceHolder = () => {
    let temp = "";
    businessCurrencies.map((i: { label: string }, index: number) => {
      temp += i.label;
      if (businessCurrencies.length !== index + 1) {
        temp += " - ";
      }
    });
    return temp;
  };

  const getDefaultCurrency = () => {
    const defaultCurrencyId = store?.businessReducer?.business?.business?.default_currency_id;
    const currencyLabel = currencies.find((item: { id: number }) => item.id == defaultCurrencyId);
    return currencyLabel?.fa_title || "";
  };
  return (
    <div className="flex container flex-col ">
      <div className="flex w-full flex-row items-center justify-between">
        <span className="text-[#7E8C9E] text-base ">سیستم انبارداری</span>
        <NewSwitch disable={true} size={2} activeColor="#30D74B" />
      </div>
      <div className="flex flex-row item-center gap-12 w-full mt-9">
        <div className="flex flex-1 flex-col item-start ">
          <BasicSelect
            disabled
            label="سیستم حسابداری انبار"
            options={warehouseAccountingSystem}
            onChange={onChange}
            // placeholder={warehouseAccountingSystem[0]?.label}
            placeholder={settingData["warehouseAccountingSystem"]}
          />
        </div>
        <div className="flex flex-1 flex-col item-start ">
          <BasicSelect
            disabled
            label="روش ارزیابی انبار"
            //value={settingData["warehouseAnalyzeSystem"]}
            options={warehouseAnalyzeSystem}
            onChange={onChange}
            //placeholder={warehouseAnalyzeSystem[0]?.label}
            placeholder={settingData["warehouseAnalyzeSystem"]}
          />
        </div>
      </div>
      <div className="flex w-full flex-row items-center justify-between mt-16 ">
        <span className="text-[#7E8C9E] text-base  ">سیستم چندارزی</span>
        <NewSwitch
          disable
          size={2}
          active={businessCurrencies?.length > 1 ? true : false}
          activeColor={"#30D74B"}
        />
      </div>
      <div className="flex flex-row item-center gap-12 w-full mt-9">
        <div className="flex flex-1 flex-col item-start ">
          <BasicSelect
            disabled
            label="واحد پول اصلی"
            options={currencies}
            onChange={onChange}
            placeholder={getDefaultCurrency()}
          />
        </div>
        <div className="flex flex-1 flex-col item-start ">
          {businessCurrencies?.length > 1 && (
            <BasicSelect
              disabled
              label="سایر ارزها"
              options={currencies}
              onChange={onChange}
              placeholder={multiCurrencyPlaceHolder()}
            />
          )}
        </div>
      </div>

      <div className="flex w-full flex-row items-center justify-between mt-16 ">
        <span className="text-[#7E8C9E] text-base  ">مالیات بر ارزش افزوده</span>
        <div className="flex flex-row item-center">
          <span className="ml-4 font-normal text-dark-2">
            {settingData["addedTax"] ? "پرداخت می کنم" : "پرداخت نمی کنم"}
          </span>
          <NewSwitch
            size={2}
            activeColor={"#30D74B"}
            active={settingData["addedTax"]}
            onChange={(value) => {
              onChange("addedTax", value);
            }}
          />
        </div>
      </div>

      <div className="flex flex-row item-center gap-12 w-full mt-9">
        <div className="flex flex-1 flex-col item-start ">
          <BasicTaxInput
            active={settingData["addedTax"]}
            value={settingData["taxRate"] || "0"}
            onChange={(value: any) => {
              onChange("taxRate", value);
            }}
            label={"نرخ مالیات ارزش افزوده"}
          />
        </div>
        <div className="flex flex-1 flex-col item-start " />
      </div>
      <div className="flex flex-row item-center gap-12 w-full mt-9">
        <div className="flex flex-1 flex-row item-start ">
          <span className="ml-4 font-normal text-dark-2">
            عدم محاسبه تراز افتتاحیه در داشبورد بدهکاران بستانکاران
          </span>
          <NewSwitch
            size={2}
            activeColor={"#30D74B"}
            active={settingData["OpeningBalanceAccountingCalculationFalse"]}
            onChange={(value) => {
              onChange("OpeningBalanceAccountingCalculationFalse", value);
            }}
          />
        </div>
        <div className="flex flex-1 flex-col item-start " />
      </div>
    </div>
  );
};

export default AccountingSettings;

const BasicTaxInput = ({
  active = true,
  label,
  value,
  onChange,
}: {
  active?: boolean;
  label?: string;
  value: string;
  onChange: (value: any) => void;
}) => {
  const add = () => {
    let temp = S2N(value);
    temp = parseFloat(temp) + 1;
    onChange(temp);
  };
  const minus = () => {
    let temp = S2N(value);
    if (temp > 0) {
      temp = parseFloat(temp) - 1;
      onChange(temp);
    } else {
      onChange(0);
    }
  };
  return (
    <div className="flex flex-col ">
      {label && <span className="mb-2">{label}</span>}
      <div
        className={`flex flex-row items-center border border-[#C2D0E3] ${!active && "bg-[#EDEEF0]"
          } rounded-md min-h-[40px] px-4 justify-between`}
      >
        <button
          onClick={() => active && minus()}
          className={` ${active ? "bg-[#FEFEFE]" : "bg-[#EDEEF0]"}  py-2 `}
        >
          <Minus />
        </button>
        <span>{value}%</span>
        <button
          onClick={() => active && add()}
          className={` ${active ? "bg-[#FEFEFE]" : "bg-[#EDEEF0]"}  py-2 `}
        >
          <Plus />
        </button>
      </div>
    </div>
  );
};

const Minus = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="2" fill="none" viewBox="0 0 18 2">
    <path fill="#8D8E8F" d="M16.5 1h-15Z" />
    <path stroke="#8D8E8F" stroke-linecap="round" strokeWidth="2" d="M16.5 1h-15" />
  </svg>
);

const Plus = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 14 14">
    <path stroke="#8D8E8F" stroke-linecap="round" strokeWidth="2" d="M1.166 7.002h11.67M7 1.167v11.67" />
  </svg>
);
